import React, { Component, Suspense, lazy } from 'react'
import store from '../../../store'
import Helmet from 'react-helmet'
import SuspenseLoader from './../../../components/suspense_loader/SuspenseLoader'
import Sidebar from './../../../components/sidebar/Sidebar'
import { TabsAndPages } from '../components/tabs_and_pages/TabsAndPages'

import './HockeyTournament.scss'
import HeaderTitle from '../../shared/HeaderTitle'

const WJCTournament = lazy(() => import('./wjc/WJCTournament'))
const WHCTournament = lazy(() => import('./whc/WHCTournament'))
const WWHCTournament = lazy(() => import('./wwhc/WWHCTournament'))
const CHLTournament = lazy(() => import('./chl/CHLTournament'))
const FourNationsTournament = lazy(() => import('./fournations/FourNationsTournament'))

const OlympicsPage = lazy(() => import('./olympics/OlympicsPage'))

class HockeyTournament extends Component {
    componentDidMount() {
        store.dispatch({
            type: 'ANALYTIC_EVENT_PAGE',
            naming: {
                sport: this.props.sport,
                league: this.props.league,
                page: 'tournament',
                url: window.location.href || document.URL,
            },
        })
    }

    render() {
        const { league, sport } = this.props
        const { year, page } = this.props.match.params
        const leagueFormatted =
            league === '4nationsfaceoff' ? '4 Nations Face-Off' : league.toUpperCase()

        let seasonYear = year ? year : new Date().getFullYear()
        let tabsAndPageData = [
            {
                display_name: "Women's Hockey",
                page: 'womens',
                league: 'olympics',
                sport: 'hockey',
                active: page === 'womens',
                show_tab: true,
                component: props => <OlympicsPage league="oly_whk" year={seasonYear} {...props} />,
            },
            {
                display_name: "Men's Hockey",
                page: 'mens',
                league: 'olympics',
                sport: 'hockey',
                active: page === 'mens',
                show_tab: true,
                component: props => <OlympicsPage league="oly_mhk" year={seasonYear} {...props} />,
            },
        ]

        return (
            <div className="HockeyTournament__cont">
                <Helmet
                    title={`${leagueFormatted} - Sportsnet.ca`}
                    link={[
                        {
                            rel: 'canonical',
                            href: `${window.location.origin}/${sport}/${league}`,
                        },
                    ]}
                >
                    <meta
                        name="description"
                        content={`Your source for ${leagueFormatted} schedule and score information.`}
                    />
                </Helmet>

                <div className="inner_cont">
                    <div className="left_col">
                        {league === 'oly' && (
                            <>
                                <HeaderTitle title={'Olympic Hockey'}></HeaderTitle>

                                <TabsAndPages pageData={tabsAndPageData} year={year} />
                            </>
                        )}

                        <Suspense fallback={<SuspenseLoader />}>
                            {league === 'wjc' && <WJCTournament {...this.props} />}
                            {league === 'whc' && <WHCTournament {...this.props} />}
                            {league === 'wwhc' && <WWHCTournament {...this.props} />}
                            {league === 'chl' && <CHLTournament {...this.props} />}
                            {league === '4nationsfaceoff' && (
                                <FourNationsTournament {...this.props} />
                            )}
                        </Suspense>
                    </div>

                    <div className="right_col">
                        <Sidebar league={league} sport={sport} year={seasonYear} />
                    </div>
                </div>
            </div>
        )
    }
}

export default HockeyTournament
